import { gql } from '@apollo/client';

export const GET_ALL_VEHICLE_TYPES = gql`
  query GetAllVehicleTypes {
    getAllVehicleTypes {
      id
      nameEn
      nameZh
      nameEs
    }
  }
`;

export interface VehicleType {
  id: string;
  nameEn: string;
  nameZh: string;
  nameEs: string;
}

export interface GetAllVehicleTypesResponse {
  getAllVehicleTypes: VehicleType[];
} 